"use client";

import { Box, Typography, Grid } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useEffect, useState } from "react";

const BadgeSelector = ({ badges, onSelectBadge, selectedBadgePath }) => {
    const [selected, setSelected] = useState(null);

    // Handle default selection on first render if nothing selected
    useEffect(() => {
        if (!selectedBadgePath) {
            const defaultBadge = badges.find((badge) => badge.defaultBadge);
            if (defaultBadge) {
                setSelected(defaultBadge.path);
                onSelectBadge(defaultBadge);
            }
        } else {
            setSelected(selectedBadgePath);
        }
    }, [badges, selectedBadgePath, onSelectBadge]);

    const handleBadgeClick = (badge) => {
        if (selected === badge.path) {
            // Deselect
            setSelected(null);
            onSelectBadge({ path: "" });
        } else {
            // Select new
            setSelected(badge.path);
            onSelectBadge(badge);
        }
    };

    return (
        <Box sx={{ width: "100%", mt: 1 }}>
            <Grid container direction="column" gap={1}>
                {badges.map((badge) => {
                    const isSelected = selected === badge.path;
                    return (

                        <Box
                            onClick={() => handleBadgeClick(badge)}
                            sx={{
                                position: "relative",
                                height: 200,
                                width: 200,
                                borderRadius: 2,
                                overflow: "hidden",
                                bgcolor: "#fff",
                                border: `2px solid ${isSelected ? "#4caf50" : "#e0e0e0"}`,
                                cursor: "pointer",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                                },
                            }}
                        >
                            <img
                                src={badge.image || "/placeholder.svg"}
                                alt={`Badge ${badge.id}`}
                                style={{
                                    height: "100%",
                                    objectFit: "cover",
                                    flexShrink: 0,
                                }}
                            />


                            {isSelected && (
                                <CheckCircleIcon
                                    sx={{
                                        color: "#4caf50",
                                        fontSize: 28,
                                        position: "absolute",
                                        top: 8,
                                        right: 8,
                                        bgcolor: "#fff",
                                        borderRadius: "50%",
                                    }}
                                />
                            )}
                        </Box>

                    );
                })}
            </Grid>
        </Box>
    );
};

export default BadgeSelector;
